import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import NewsSection from "@/components/NewsSection";

// Lazy load below-fold sections to improve Speed Index
const JobOffersSection = lazy(() => import("@/components/JobOffersSection"));
const AgencyFinderSection = lazy(() => import("@/components/AgencyFinderSection"));
const CompanySection = lazy(() => import("@/components/CompanySection"));
const ImpactSection = lazy(() => import("@/components/ImpactSection"));
const Footer = lazy(() => import("@/components/Footer"));

// Simple loading placeholder that doesn't cause layout shift
const SectionPlaceholder = () => (
  <div className="py-16 lg:py-24 animate-pulse bg-muted/20" />
);

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <NewsSection />
        <Suspense fallback={<SectionPlaceholder />}>
          <JobOffersSection />
        </Suspense>
        <Suspense fallback={<SectionPlaceholder />}>
          <AgencyFinderSection />
        </Suspense>
        <Suspense fallback={<SectionPlaceholder />}>
          <CompanySection />
        </Suspense>
        <Suspense fallback={<SectionPlaceholder />}>
          <ImpactSection />
        </Suspense>
      </main>
      <Suspense fallback={<div className="h-64 bg-muted/20" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
